export default __webpack_public_path__ + "static/N0186-640b7db6aeba051a49610493e65cbe16.png";